import gql from "graphql-tag";

const LATEST_BLOGS_QUERY = gql`
    query{
        blogs(limit: 1, sort:"createdAt:desc"){
            id,
            title
        }
    }
`;

export default LATEST_BLOGS_QUERY